import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export type FacilityGroupRecord = QueryAtomResult<
  typeof queryFacilityGroupsAtom
>[number];

export const queryFacilityGroupsAtom = createQueryAtomFactory(
  'settings.facilityGroups',
  (params: { searchTerm?: string }) => ({
    facilityGroups: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        pagination: {
          offset: 0,
          limit: 300,
        },
      },
      entries: {
        id: true,
        name: true,
        facilities: {
          id: true,
          facilityName: true,
          facilityType: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data) =>
      data?.facilityGroups.entries.map((group) => ({
        id: group.id,
        name: group.name,
        facilities:
          group.facilities?.map((facility) => ({
            id: facility.id,
            name: facility.facilityName,
            type: facility.facilityType,
          })) ?? [],
        timestamps: {
          createdAt: parseZonedDateTime(group.timestamps.createdAt),
          updatedAt: parseZonedDateTime(group.timestamps.updatedAt),
        },
      })) ?? [],
  },
);
